"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _abcjs = _interopRequireDefault(require("@bittnerdevelopmentgroup/abcjs"));
require("./MusicEditor.css");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _CompletedContext = require("../CompletedContext");
var _fractional = require("fractional");
var _MusicUtil = require("./MusicUtil");
var _pause = _interopRequireDefault(require("../assets/MusicEditor/pause.png"));
var _play = _interopRequireDefault(require("../assets/MusicEditor/play.png"));
var _play_disabled = _interopRequireDefault(require("../assets/MusicEditor/play_disabled.png"));
var _whole = _interopRequireDefault(require("../assets/MusicEditor/whole.png"));
var _util = require("../util");
var _greenCheckIcon = _interopRequireDefault(require("../assets/green-check-icon.png"));
var _redXIcon = _interopRequireDefault(require("../assets/red-x-icon.png"));
var _TaskChordBuilder = require("./TaskChordBuilder");
var _excluded = ["pitches"],
  _excluded2 = ["pitches"];
var DEBUG = false;
var midiBuffer;
function describeLineSpace(note, ingoreAccidental) {
  var accidental = note.accidental && !ingoreAccidental ? " with " + note.accidental.replace("dbl", "double ") : "";
  return _MusicUtil.verticalPos_to_lineSpace[note.verticalPos] + accidental;
}
var MusicEditor = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MusicEditor, _React$Component);
  var _super = (0, _createSuper2.default)(MusicEditor);
  function MusicEditor(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MusicEditor);
    _this = _super.call(this, props);
    DEBUG && console.log("MusicEditor constructor");
    var splitPrecursor = _this.props.precursor.split(" ");
    _this.clef = splitPrecursor[splitPrecursor.length - 1].replace(/\n/g, '');
    _this.state = {
      width: 300,
      accidental: "",
      duration: undefined,
      cursorNote: 0,
      cursorPitch: _this.clef === "treble" ? 0 : _this.clef === "alto" ? 6 : 12 /*bass*/,
      editorActive: false,
      clicked: false,
      annotations: props.perNoteAnnotationAltText !== undefined ? props.perNoteAnnotationAltText.split(",") : undefined,
      lastDirection: "",
      summary: _this.generateSummary(),
      screenTooSmall: false
    };
    _this.updateWidth = _this.updateWidth.bind((0, _assertThisInitialized2.default)(_this));
    _this.callback = _this.callback.bind((0, _assertThisInitialized2.default)(_this));
    _this.playButton = _this.playButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderNotation = _this.renderNotation.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInput = _this.handleInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.findNoteByIndex = _this.findNoteByIndex.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateCurrentHotspot = _this.updateCurrentHotspot.bind((0, _assertThisInitialized2.default)(_this));
    _this.describeVerticalPitchClass = _this.describeVerticalPitchClass.bind((0, _assertThisInitialized2.default)(_this));
    _this.changePlayState = _this.changePlayState.bind((0, _assertThisInitialized2.default)(_this));
    _this.setAccidental = _this.setAccidental.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCursor = _this.resetCursor.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(MusicEditor, [{
    key: "getStaffRef",
    value: function getStaffRef() {
      return this.ref;
    }
  }, {
    key: "serializeNote",
    value: function serializeNote(note, extra, clef) {
      var ret = "";
      if (note.chord) {
        var _iterator = (0, _createForOfIteratorHelper2.default)(note.chord),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _annotation_position_;
            var chord = _step.value;
            ret += "\"".concat((_annotation_position_ = _MusicUtil.annotation_position_to_character[chord.position]) !== null && _annotation_position_ !== void 0 ? _annotation_position_ : "@").concat(chord.name, "\"");
            DEBUG && console.log("serializeNote chord", chord);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (note.gracenotes) {
        ret += "{";
        var _iterator2 = (0, _createForOfIteratorHelper2.default)(note.gracenotes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var grace = _step2.value;
            if (clef === "treble") {
              ret += (0, _MusicUtil.get_treble_pitch)(grace.pitch);
            } else if (clef === "bass") {
              ret += (0, _MusicUtil.get_bass_pitch)(grace.pitch);
            } else if (clef === "alto") {
              ret += (0, _MusicUtil.get_alto_pitch)(grace.pitch);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ret += "}";
      }
      if (note.decoration) {
        var _iterator3 = (0, _createForOfIteratorHelper2.default)(note.decoration),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var dec = _step3.value;
            if (dec === "irishroll") {
              ret += "~";
            } else {
              console.log("unknown decoration: ", dec);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      if (note.rest) {
        ret += "z";
      } else if (note.pitches) {
        if (note.pitches.length > 1) {
          ret += "[";
        }
        var _iterator4 = (0, _createForOfIteratorHelper2.default)(note.pitches),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var pitch = _step4.value;
            if (clef === "bass") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_bass_pitch)(pitch.verticalPos);
            } else if (clef === "treble") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_treble_pitch)(pitch.pitch);
            } else if (clef === "alto") {
              ret += (_MusicUtil.accidentals[pitch.accidental] || "") + (0, _MusicUtil.get_alto_pitch)(pitch.verticalPos);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (note.pitches.length > 1) {
          ret += "]";
        }
      }
      var default_length = this.lastParse && this.lastParse[0].multilineVars && this.lastParse[0].multilineVars.default_length || 0.25;
      if (note.duration !== default_length) {
        var ratio = new _fractional.Fraction(note.duration / default_length);
        var frac = ratio.numerator;
        if (ratio.denominator !== 1) frac += "/" + ratio.denominator;
        ret += frac;
      }
      DEBUG && console.log("serializeNote extra", extra);
      if (extra === undefined) extra = note.endChar - note.startChar - ret.length;
      DEBUG && console.log("serializeNote extra now", extra);
      if (extra > 0) {
        if (note.pitches && (note.pitches[0].startSlur || note.pitches[0].endSlur)) extra--;else ret += " ".repeat(extra);
      }
      DEBUG && console.log("serializeNote ret", ret);
      return ret;
    }
  }, {
    key: "getMissingNoteIndexes",
    value: function getMissingNoteIndexes(currentNotes) {
      var _this2 = this;
      if (this.props.correctPitches) {
        var missingNoteIndexes = [];
        if (this.props.chordMode) {
          var _loop = function _loop(i) {
            if (currentNotes.findIndex(function (note) {
              return _this2.props.correctPitches[i].verticalPos === note.verticalPos;
            }) === -1) {
              missingNoteIndexes.push(i);
            }
          };
          for (var i = 0; i < this.props.correctPitches.length; ++i) {
            _loop(i);
          }
        } // not required for scalebuilder
        return missingNoteIndexes;
      }
    }
  }, {
    key: "callback",
    value: function callback(pitch, e, manual) {
      if (this.props.completed || this.props.hintMode) {
        return;
      }
      var offset = this.props.precursor ? this.props.precursor.length : 0;
      var oldNote = this.props.notation.substring(e.abcelem.startChar - offset, e.abcelem.endChar - offset);
      var altTextPitchMode = this.props.altTextMode !== "lineSpace" ? true : false;
      var _iterator5 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var line = _step5.value;
          var _iterator6 = (0, _createForOfIteratorHelper2.default)(line.staff),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var staff = _step6.value;
              var _iterator7 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var voice = _step7.value;
                  var i = 0;
                  var clef = staff.clef.type;
                  var _iterator8 = (0, _createForOfIteratorHelper2.default)(voice),
                    _step8;
                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      var note = _step8.value;
                      // console.log(note)
                      if (note.startChar === e.abcelem.startChar) {
                        // console.log("^^matched note!")
                        var new_pitch = {
                          pitch: pitch,
                          verticalPos: pitch,
                          accidental: _MusicUtil.accidentals_code[this.state.accidental]
                        };
                        // check how long the note is before doing anything
                        DEBUG && console.log("callback doing old extra");
                        var oldExtra = note.endChar - note.startChar - this.serializeNote(note, 0, clef).length;
                        DEBUG && console.log("callback oldExtra", oldExtra);
                        note.duration = this.state.duration; // TODO: enforce all notes in a measure adding up to 1
                        if (note.rest) {
                          note.rest = undefined;
                          note.pitches = [new_pitch];
                          (0, _util.srSpeak)("Note ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), " added. "), "hotkey-announcer");
                        } else if (note.pitches) {
                          if (this.props.monophonic) {
                            if (note.pitches[0].verticalPos !== new_pitch.pitch || note.pitches[0].accidental !== new_pitch.accidental) {
                              note.pitches = [new_pitch];
                              (0, _util.srSpeak)("Note changed to ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), ". "), "hotkey-announcer");
                            } else {
                              note.rest = {
                                type: 'rest'
                              };
                              var _note = note,
                                pitches = _note.pitches,
                                noteTemp = (0, _objectWithoutProperties2.default)(_note, _excluded);
                              note = noteTemp;
                              (0, _util.srSpeak)("Note ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), " removed. "), "hotkey-announcer");
                            }
                          } else {
                            var _this$props;
                            var _i = note.pitches.findIndex(function (e) {
                              return e.verticalPos === pitch;
                            });
                            if (_i !== -1) {
                              if (note.pitches[_i].accidental === new_pitch.accidental) {
                                note.pitches.splice(_i, 1);
                                (0, _util.srSpeak)("Note ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), " removed. "), "hotkey-announcer");
                              } else {
                                note.pitches.splice(_i, 1, new_pitch);
                                (0, _util.srSpeak)("Note changed to ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), ". "), "hotkey-announcer");
                              }
                            } else {
                              note.pitches.push(new_pitch);
                              note.pitches.sort(function (a, b) {
                                return a.pitch - b.pitch;
                              });
                              (0, _util.srSpeak)("Note ".concat(altTextPitchMode ? (0, _MusicUtil.describePitch)(new_pitch) : "on " + describeLineSpace(new_pitch), " added. "), "hotkey-announcer");
                            }
                            if (note.pitches.length === 0) {
                              note.rest = {
                                type: 'rest'
                              };
                              var _note2 = note,
                                _pitches = _note2.pitches,
                                _noteTemp = (0, _objectWithoutProperties2.default)(_note2, _excluded2);
                              note = _noteTemp;
                            }
                            if (((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.chordAnswerState[new_pitch.pitch]) !== undefined) {
                              var newAnswerState = (0, _objectSpread2.default)({}, this.props.chordAnswerState);
                              newAnswerState[new_pitch.pitch] = undefined;
                              this.props.changeAnswerState(newAnswerState);
                            }
                          }
                        }
                        if (this.props.scaleAnswerState) {
                          var _newAnswerState = (0, _objectSpread2.default)({}, this.props.scaleAnswerState);
                          _newAnswerState[i] = undefined;
                          this.props.changeAnswerState(_newAnswerState);
                        }
                        DEBUG && console.log("callback doing actual");
                        oldNote = this.serializeNote(note, oldExtra, clef);
                        this.setState({
                          cursorNote: i,
                          cursorPitch: pitch
                        });
                      }
                      if (note.el_type === "note") ++i;
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var newNotation = this.props.notation.substring(0, e.abcelem.startChar - offset) + oldNote + this.props.notation.substring(e.abcelem.endChar - offset);
      this.props.onChange(newNotation);
    }
  }, {
    key: "updateWidth",
    value: function updateWidth() {
      if (window.innerWidth < 728) {
        // musicEditor does not support smaller screens
        this.setState({
          screenTooSmall: true
        });
      } else {
        this.setState({
          screenTooSmall: false
        });
      }
      if (this.state.width !== this.container.offsetWidth) this.setState({
        width: this.container.offsetWidth
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.updateWidth);
      this.updateWidth();
      DEBUG && console.log("MusicEditor componentDidMount rendering");
      this.renderNotation();
      this.setAriaLabels();
      this.setState({
        duration: this.lastParse && this.lastParse[0].multilineVars && this.lastParse[0].multilineVars.default_length || 0.25
      });
      // this.unitTest()

      window.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateWidth);
      window.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "describeVerticalPitchClass",
    value: function describeVerticalPitchClass(verticalPos) {
      var _this$props$rangeLowe, _this$props$rangeUppe;
      if (verticalPos < ((_this$props$rangeLowe = this.props.rangeLower) !== null && _this$props$rangeLowe !== void 0 ? _this$props$rangeLowe : -3) || verticalPos > ((_this$props$rangeUppe = this.props.rangeUpper) !== null && _this$props$rangeUppe !== void 0 ? _this$props$rangeUppe : 15)) return '?';
      var clef = this.lastParse[0].lines[0].staff[0].clef.type;
      if (clef === "treble") return (0, _MusicUtil.describeTreblePitchPos)(verticalPos);else if (clef === "alto") return (0, _MusicUtil.describeAltoPitchPos)(verticalPos);else if (clef === "bass") return (0, _MusicUtil.describeBassPitchPos)(verticalPos);
    }
  }, {
    key: "getKeyAccidental",
    value: function getKeyAccidental(verticalPos) {
      var _iterator9 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines[0].staff[0].key.accidentals),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var accidental = _step9.value;
          if (accidental.verticalPos === verticalPos) {
            return accidental.acc;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "renderNotation",
    value: function renderNotation() {
      var _this3 = this;
      var render_config = {
        add_hotspots: true,
        // hotspots need to exist so icons have an anchor point
        add_classes: this.props.addClasses,
        hotspot_width_scale: this.props.hotspotWidthScale || 1,
        scale: this.props.zoom || 1,
        staffwidth: this.state.width || "95%",
        click_line_callback: this.callback,
        paddingtop: 0,
        paddingbottom: 0,
        paddingleft: 0,
        paddingright: 0,
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper
      };
      if (this.props.musicStaffWrap) {
        render_config.wrap = {
          minspacing: 1.8,
          maxspacing: 2.7,
          preferredmeasuresperline: 4
        };
      }
      this.lastParse = _abcjs.default.renderAbc(this.container, (this.props.precursor || "") + this.props.notation + "||", render_config);
      //console.log("lastParse", this.lastParse)

      if (this.props.onRender) this.props.onRender(this.lastParse);

      // Make sure numNotes is updated
      this.findNoteByIndex(0);
      var svg = this.lastParse[0].engraver.renderer.paper.svg;
      for (var j = (_this$props$rangeUppe2 = this.props.rangeUpper) !== null && _this$props$rangeUppe2 !== void 0 ? _this$props$rangeUppe2 : 15; j >= ((_this$props$rangeLowe2 = this.props.rangeLower) !== null && _this$props$rangeLowe2 !== void 0 ? _this$props$rangeLowe2 : -3); j--) {
        var _this$props$rangeUppe2, _this$props$rangeLowe2;
        var row = document.createElementNS("http://www.w3.org/2000/svg", "g");
        var pitch = this.describeVerticalPitchClass(j);
        var acc = this.getKeyAccidental(j);
        if (acc) {
          pitch += " ".concat(acc);
        }
        if (j >= 2 && j <= 10) {
          pitch += " staff";
        } else {
          pitch += " ledger";
        }
        if (j & 1) {
          // is the number odd?
          pitch += " space";
        } else {
          pitch += " line";
        }
        if (this.props.hintMode || this.props.imageOnly) {
          svg.setAttribute("aria-hidden", "true");
          svg.style.setProperty("pointer-events", "none");
        } else {
          svg.setAttribute("role", "none");
        }
        for (var i = 0; i < this.numNotes; i++) {
          var note = this.findNoteByIndex(i);
          if (note && note.hotspots) {
            var hotspot = note.hotspots["" + j];
            if (hotspot) {
              hotspot.setAttribute("id", this.props.hintMode ? "music-editor-cell-".concat(j, "-").concat(i + 1, "-hint") : "music-editor-cell-".concat(j, "-").concat(i + 1));
              if (this.props.hintMode) {
                hotspot.setAttribute("class", hotspot.getAttribute("class") + "-hint");
              } else {
                row.appendChild(hotspot);
                svg.appendChild(row);
              }
            }
          }
        }
      }
      var svgns = "http://www.w3.org/2000/svg";
      var removeAnnotationsRegex = /\".*?\"/g;
      var hasAnnotations = this.props.notation.search(removeAnnotationsRegex) !== -1;
      // Mark up the hotspots for aria
      var _loop2 = function _loop2() {
        var note = _this3.findNoteByIndex(_i2);
        if (note && note.hotspots && !_this3.props.hintMode) {
          if (_this3.props.chordAnswerState) {
            Object.keys(_this3.props.chordAnswerState).map(function (index) {
              if (_this3.props.chordAnswerState[index] === undefined) {
                return;
              }
              var element = note.hotspots["" + index];
              element.setAttribute('class', element.getAttribute('class') + (_this3.props.chordAnswerState[index] ? " staff-position-correct" : " staff-position-incorrect"));
              element.setAttribute("height", "3.9"); // prevent overlap
              var img = document.createElementNS(svgns, "image");
              img.setAttribute("href", _this3.props.chordAnswerState[index] ? _greenCheckIcon.default : _redXIcon.default);
              img.setAttribute("height", "4");
              img.setAttribute("width", "4");
              img.classList.add("apply-dark-mode");
              img.setAttribute("x", "".concat(171 * (_this3.props.musicStaffWidth ? parseInt(_this3.props.musicStaffWidth) / 100 : 1)));
              img.setAttribute("y", element.getAttribute("y"));
              element.insertAdjacentElement("afterend", img);
            });
          } else if (_this3.props.scaleAnswerState) {
            if (_this3.props.scaleAnswerState[_i2] === undefined) {
              return "continue";
            }
            // place images under the notes or annotations
            var bottomElement = document.getElementById("music-editor-cell-".concat(_this3.props.rangeLower, "-").concat(_i2 + 1));
            if (bottomElement) {
              var _this3$props$iconOffs, _this3$props$iconOffs2, _this3$props$iconOffs3, _this3$props$iconOffs4, _this3$props$iconOffs5, _this3$props$iconOffs6;
              var img = document.createElementNS(svgns, "image");
              var yOffset = !hasAnnotations ? (_this3$props$iconOffs = (_this3$props$iconOffs2 = _this3.props.iconOffsets) === null || _this3$props$iconOffs2 === void 0 ? void 0 : _this3$props$iconOffs2.yOffsetNoAnnotation) !== null && _this3$props$iconOffs !== void 0 ? _this3$props$iconOffs : 10 : (_this3$props$iconOffs3 = (_this3$props$iconOffs4 = _this3.props.iconOffsets) === null || _this3$props$iconOffs4 === void 0 ? void 0 : _this3$props$iconOffs4.yOffsetWithAnnotation) !== null && _this3$props$iconOffs3 !== void 0 ? _this3$props$iconOffs3 : 25;
              img.setAttribute("href", _this3.props.scaleAnswerState[_i2] ? _greenCheckIcon.default : _redXIcon.default);
              img.setAttribute("height", "12.75");
              img.setAttribute("width", "12.75");
              img.classList.add("apply-dark-mode");
              img.setAttribute("x", parseInt(bottomElement.getAttribute("x")) + ((_this3$props$iconOffs5 = (_this3$props$iconOffs6 = _this3.props.iconOffsets) === null || _this3$props$iconOffs6 === void 0 ? void 0 : _this3$props$iconOffs6.xOffset) !== null && _this3$props$iconOffs5 !== void 0 ? _this3$props$iconOffs5 : 6));
              img.setAttribute("y", parseInt(bottomElement.getAttribute("y")) + yOffset);
              bottomElement.parentElement.insertAdjacentElement("afterend", img);
            }
          }
        }
      };
      for (var _i2 = 0; _i2 < this.numNotes; _i2++) {
        var _ret = _loop2();
        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "getCurrentNotes",
    value: function getCurrentNotes() {
      var _this4 = this;
      var removeAnnotationsRegex = /\".*?\"/g;
      if (this.props.chordMode) {
        return (0, _TaskChordBuilder.splitNotation)(this.props.notation).map(function (v) {
          return v === "z" ? v : (0, _MusicUtil.letter_to_pitch)(v, _this4.clef);
        });
      } else {
        // scale builder
        var answerString = this.props.notation.replace(removeAnnotationsRegex, "").replaceAll("|", "");
        return (0, _TaskChordBuilder.splitNotation)(answerString).map(function (v) {
          return v === "z" ? v : (0, _MusicUtil.letter_to_pitch)(v, _this4.clef);
        });
      }
    }
  }, {
    key: "setAriaLabels",
    value: function setAriaLabels() {
      var _this5 = this;
      // Mark up the hotspots for aria
      var currentNotes = this.getCurrentNotes();
      var missingNoteIndexes = this.getMissingNoteIndexes(currentNotes);
      var _loop3 = function _loop3(i) {
        var note = _this5.findNoteByIndex(i);
        if (note && note.hotspots) {
          var _loop4 = function _loop4(j) {
            var hotspot = note.hotspots["" + j];
            if (hotspot) {
              hotspot.setAttribute("role", "button");
              hotspot.setAttribute("tabindex", "-1");
              var ariaPressed = "false";
              if (!_this5.props.hintMode) {
                if (_this5.state.cursorNote === i && _this5.state.cursorPitch === j) {
                  var label = "";
                  if (_this5.props.chordMode) {
                    if (_this5.props.altTextMode === "lineSpace") {
                      label = "Cursor at " + describeLineSpace({
                        verticalPos: j,
                        accidental: _MusicUtil.accidentals_code[_this5.state.accidental]
                      });
                    } else {
                      // pitch mode (default)
                      label = "Cursor at pitch " + _this5.describeVerticalPitchClass(j) + " " + (_this5.state.accidental !== "" ? _MusicUtil.accidentals_code[_this5.state.accidental] : "");
                    }
                  } else {
                    // scale builder
                    var includeBeat = _this5.state.lastDirection === "left" || _this5.state.lastDirection === "right";
                    if (currentNotes[i].verticalPos === j) {
                      ariaPressed = "true";
                    }
                    if (_this5.state.lastDirection === "") {
                      // focus came from outside of the music editor
                      if (_this5.props.altTextMode === "lineSpace") {
                        label = "Beat ".concat(i + 1) + " at " + describeLineSpace({
                          verticalPos: j,
                          accidental: _MusicUtil.accidentals_code[_this5.state.accidental]
                        }) + (_this5.state.annotations ? ", Annotation is " + _this5.state.annotations[i] : "");
                      } else {
                        // pitch mode (default)
                        label = "Beat ".concat(i + 1) + " at pitch " + _this5.describeVerticalPitchClass(j) + (_this5.state.accidental !== "" ? " " + _MusicUtil.accidentals_code[_this5.state.accidental].replace("dbl", "double ") : "") + (_this5.state.annotations ? ", Annotation is " + _this5.state.annotations[i] : "");
                      }
                      if (currentNotes[i] === "z") {
                        label += ". Note missing";
                      } else {
                        label += ". Current note" + (_this5.props.altTextMode === "lineSpace" ? " on " + describeLineSpace(currentNotes[i]) : " is " + (0, _MusicUtil.describePitch)(currentNotes[i]));
                      }
                    } else {
                      if (includeBeat) {
                        label += "Beat ".concat(i + 1) + (_this5.state.annotations ? ". Annotation is " + _this5.state.annotations[i] : "");
                        if (currentNotes[i] === "z") {
                          label += ". Note missing";
                        } else {
                          label += ". Current note" + (_this5.props.altTextMode === "lineSpace" ? " on " + describeLineSpace(currentNotes[i]) : " is " + (0, _MusicUtil.describePitch)(currentNotes[i]));
                        }
                        if (_this5.props.scaleAnswerState && _this5.props.scaleAnswerState[i] !== undefined) {
                          label += _this5.props.scaleAnswerState[i] ? " correct" : " incorrect";
                        }
                      } else {
                        // only include pitch
                        label += _this5.props.altTextMode === "lineSpace" ? describeLineSpace({
                          verticalPos: j,
                          accidental: _MusicUtil.accidentals_code[_this5.state.accidental]
                        }) : _this5.describeVerticalPitchClass(j) + (_this5.state.accidental !== "" ? " " + _MusicUtil.accidentals_code[_this5.state.accidental].replace("dbl", "double ") : "");
                      }
                    }
                  }
                  if (_this5.props.chordAnswerState && _this5.props.chordAnswerState[j] !== undefined) {
                    label += _this5.props.chordAnswerState[j] ? " correct" : " incorrect";
                    var _iterator10 = (0, _createForOfIteratorHelper2.default)(missingNoteIndexes),
                      _step10;
                    try {
                      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                        var missingNoteIndex = _step10.value;
                        if (_this5.props.correctPitches[missingNoteIndex].verticalPos === j) {
                          label += " and missing";
                        }
                      }
                    } catch (err) {
                      _iterator10.e(err);
                    } finally {
                      _iterator10.f();
                    }
                  }
                  label += ". ";
                  hotspot.setAttribute("aria-label", label);
                } else {
                  hotspot.setAttribute("aria-label", "");
                }
                hotspot.setAttribute("aria-pressed", ariaPressed);
              }
            }
            hotspot.addEventListener('mouseenter', function () {
              _this5.setState({
                cursorNote: i,
                cursorPitch: j,
                editorActive: true,
                lastDirection: ""
              });
            });
          };
          for (var j = (_this5$props$rangeUpp = _this5.props.rangeUpper) !== null && _this5$props$rangeUpp !== void 0 ? _this5$props$rangeUpp : 15; j >= ((_this5$props$rangeLow = _this5.props.rangeLower) !== null && _this5$props$rangeLow !== void 0 ? _this5$props$rangeLow : -3); j--) {
            var _this5$props$rangeUpp, _this5$props$rangeLow;
            _loop4(j);
          }
        }
      };
      for (var i = 0; i < this.numNotes; i++) {
        _loop3(i);
      }
    }
  }, {
    key: "findNoteByIndex",
    value: function findNoteByIndex(index) {
      var ret;
      var i = 0;
      var _iterator11 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var line = _step11.value;
          var _iterator12 = (0, _createForOfIteratorHelper2.default)(line.staff),
            _step12;
          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var staff = _step12.value;
              var _iterator13 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                _step13;
              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var voice = _step13.value;
                  var _iterator14 = (0, _createForOfIteratorHelper2.default)(voice),
                    _step14;
                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var note = _step14.value;
                      if (note.el_type === "note") {
                        if (i === index) {
                          ret = note;
                        }
                        ++i;
                      }
                      this.numNotes = i;
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return ret;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var changed = [];
      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        if (this.props[key] !== prevprops[key]) {
          changed.push("props.".concat(key));
        }
      }
      for (var _i4 = 0, _Object$keys2 = Object.keys(this.state); _i4 < _Object$keys2.length; _i4++) {
        var _key = _Object$keys2[_i4];
        if (this.state[_key] !== prevstate[_key]) {
          changed.push("state.".concat(_key));
        }
      }
      if (changed.includes("props.notation") || changed.includes("state.width") || changed.includes("props.chordAnswerState") || changed.includes("props.scaleAnswerState")) {
        DEBUG && console.log("MusicEditor rerender from", changed.join(", "));
        this.renderNotation();
      }
      if (changed.length > 0) {
        this.setAriaLabels();
      }
      if (this.props.completed) {
        var notes = this.ref.current.getElementsByClassName('abcjs-note');
        var rests = this.ref.current.getElementsByClassName('abcjs-rest');
        var chord_lines = this.ref.current.getElementsByClassName('staff-line');
        var chord_spaces = this.ref.current.getElementsByClassName('staff-space');
        for (var k = 0; k < notes.length; k++) {
          notes[k].nextElementSibling.style.pointerEvents = "none";
        }
        for (var _k = 0; _k < rests.length; _k++) {
          rests[_k].nextElementSibling.style.pointerEvents = "none";
        }
        for (var _k2 = 0; _k2 < chord_lines.length; _k2++) {
          chord_lines[_k2].style.pointerEvents = "none";
        }
        for (var _k3 = 0; _k3 < chord_spaces.length; _k3++) {
          chord_spaces[_k3].style.pointerEvents = "none";
        }
      }
      if (prevstate.editorActive !== this.state.editorActive || prevstate.width !== this.state.width || prevprops.notation !== this.props.notation || prevstate.cursorNote !== this.state.note || prevstate.cursorPitch !== this.state.pitch) {
        this.updatePreviousHotspot(prevstate);
        var note = this.findNoteByIndex(this.state.cursorNote);
        this.currentNote = note;
        this.updateCurrentHotspot(note, prevstate);
      }
    }
  }, {
    key: "updatePreviousHotspot",
    value: function updatePreviousHotspot(prevstate) {
      if (prevstate.cursorNote !== this.state.cursorNote || prevstate.cursorPitch !== this.state.cursorPitch) {
        var note = this.findNoteByIndex(prevstate.cursorNote);
        if (note && note.hotspots) {
          var hotspot = note.hotspots["" + prevstate.cursorPitch];
          if (hotspot) {
            //hotspot.style.removeProperty("fill-opacity")
            //hotspot.tabIndex = "-1"

            if (hotspot.correctAccidental && this.state.accidental === hotspot.correctAccidental) {
              this.setState({
                accidental: ""
              });
            }
          }
        }
      }
    }
  }, {
    key: "updateCurrentHotspot",
    value: function updateCurrentHotspot(note, prevstate) {
      if (note.hotspots) {
        var hotspot = note.hotspots["" + this.state.cursorPitch];
        if (hotspot) {
          if (!this.props.completed && !this.props.hintMode) {
            hotspot.tabIndex = "0";
          } else {
            hotspot.tabIndex = "-1";
          }
          if (this.state.editorActive) {
            hotspot.focus({
              focusVisible: true
            });
          }
        }
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var _this$props$rangeUppe3, _this$props$rangeLowe3, _this$props$rangeUppe4, _this$props$rangeLowe4;
      if (e.keyCode === 37 && this.state.cursorNote > 0) {
        // left
        this.setState({
          cursorNote: this.state.cursorNote - 1,
          lastDirection: "left"
        });
        e.preventDefault();
      }
      if (e.keyCode === 39 && this.state.cursorNote < this.numNotes - 1) {
        // right
        this.setState({
          cursorNote: this.state.cursorNote + 1,
          lastDirection: "right"
        });
        e.preventDefault();
      }
      if (e.keyCode === 38 && this.state.cursorPitch < ((_this$props$rangeUppe3 = this.props.rangeUpper) !== null && _this$props$rangeUppe3 !== void 0 ? _this$props$rangeUppe3 : 15)) {
        // up
        this.setState({
          cursorPitch: this.state.cursorPitch + 1,
          lastDirection: "up"
        });
        e.preventDefault();
      }
      if (e.keyCode === 40 && this.state.cursorPitch > ((_this$props$rangeLowe3 = this.props.rangeLower) !== null && _this$props$rangeLowe3 !== void 0 ? _this$props$rangeLowe3 : -3)) {
        // down
        this.setState({
          cursorPitch: this.state.cursorPitch - 1,
          lastDirection: "down"
        });
        e.preventDefault();
      }
      if (e.keyCode === 13 || e.keyCode === 32) {
        if (this.currentNote) this.callback(this.state.cursorPitch, this.currentNote.abselem, true);
      }
      if ((e.keyCode === 33 || e.keyCode === 36 && e.ctrlKey) && this.state.cursorPitch < ((_this$props$rangeUppe4 = this.props.rangeUpper) !== null && _this$props$rangeUppe4 !== void 0 ? _this$props$rangeUppe4 : 15)) {
        var _this$props$rangeUppe5;
        // PgUp or ctrl home
        this.setState({
          cursorPitch: (_this$props$rangeUppe5 = this.props.rangeUpper) !== null && _this$props$rangeUppe5 !== void 0 ? _this$props$rangeUppe5 : 15
        });
        e.preventDefault();
      }
      if ((e.keyCode === 34 || e.keyCode === 35 && e.ctrlKey) && this.state.cursorPitch > ((_this$props$rangeLowe4 = this.props.rangeLower) !== null && _this$props$rangeLowe4 !== void 0 ? _this$props$rangeLowe4 : -3)) {
        var _this$props$rangeLowe5;
        // PgDn or ctrl end
        this.setState({
          cursorPitch: (_this$props$rangeLowe5 = this.props.rangeLower) !== null && _this$props$rangeLowe5 !== void 0 ? _this$props$rangeLowe5 : -3
        });
        e.preventDefault();
      }
      if (e.keyCode === 35 && this.state.cursorNote < this.numNotes - 1) {
        // end
        this.setState({
          cursorNote: this.numNotes - 1
        });
        e.preventDefault();
      }
      if (e.keyCode === 36 && this.state.cursorNote > 0) {
        // home
        this.setState({
          cursorNote: 0
        });
        e.preventDefault();
      }
      if (e.defaultPrevented) {
        this.setState({
          editorActive: true
        });
      }
    }
  }, {
    key: "generatePlaybackNotation",
    value: function generatePlaybackNotation(precursor, notation) {
      if (!this.props.chordMode) {
        var removeAnnotationsRegex = /\".*?\"/g;
        var seperatedNotation = (0, _TaskChordBuilder.splitNotation)(notation.replace(removeAnnotationsRegex, "").replaceAll("|", ""));
        var woodBlockNotation = "\nK:C perc\nV:2\n";
        for (var i = 0; i < seperatedNotation.length; ++i) {
          woodBlockNotation = woodBlockNotation.concat(seperatedNotation[i] === "z" ? "E" : "z");
        }
        return precursor + "V:1\n" + notation + woodBlockNotation;
      }
      var playback = "";
      var playbackChord = "[";
      var parse = _abcjs.default.parseOnly(precursor + notation);
      var clef = parse[0].lines[0].staff[0].clef.type;
      var notes = parse[0].lines[0].staff[0].voices[0];
      notes[0].pitches.sort(function (a, b) {
        return a.pitch < b.pitch ? -1 : 1;
      });
      var _iterator15 = (0, _createForOfIteratorHelper2.default)(notes),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var note = _step15.value;
          if (note.pitches) {
            var _iterator16 = (0, _createForOfIteratorHelper2.default)(note.pitches),
              _step16;
            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var pitch = _step16.value;
                var new_note = {
                  "duration": note.duration,
                  "pitches": [pitch],
                  "el_type": "note"
                };
                playback += this.serializeNote(new_note, 0, clef) + "/";
                playbackChord += this.serializeNote(new_note, 0, clef);
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
          }
          playbackChord += "]";
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return (precursor || "") + playback + playbackChord;
    }
  }, {
    key: "changePlayState",
    value: function changePlayState(s) {
      this.setState({
        playing: s
      });
    }
  }, {
    key: "playButton",
    value: function playButton() {
      var _this6 = this;
      if (this.state.playing) {
        //pause button
        this.midiBuffer.pause();
        this.changePlayState(false);
      } else {
        //play button
        this.changePlayState(true);
        if (this.midiBuffer && this.midiBuffer.pausedTimeSec) {
          this.midiBuffer.resume();
        } else {
          var playback = this.generatePlaybackNotation(this.props.precursor || "", this.props.notation);
          var parse = _abcjs.default.parseOnly(playback)[0];
          if (_abcjs.default.synth.supportsAudio()) {
            // stopAudioButton.setAttribute("style", "");
            // An audio context is needed - this can be passed in for two reasons:
            // 1) So that you can share this audio context with other elements on your page.
            // 2) So that you can create it during a user interaction so that the browser doesn't block the sound.
            // Setting this is optional - if you don't set an audioContext, then abcjs will create one.
            window.AudioContext = window.AudioContext || window.webkitAudioContext || navigator.mozAudioContext || navigator.msAudioContext;
            var audioContext = new window.AudioContext();
            // This does a bare minimum so this object could be created in advance, or whenever convenient.
            midiBuffer = new _abcjs.default.synth.CreateSynth();

            // midiBuffer.init preloads and caches all the notes needed. There may be significant network traffic here.
            this.midiBuffer = midiBuffer;
            return midiBuffer.init({
              visualObj: parse,
              audioContext: audioContext,
              millisecondsPerMeasure: this.props.millisecondsPerMeasure || 2000
            }).then(function () {
              // midiBuffer.prime actually builds the output buffer.
              midiBuffer.prime();
              midiBuffer.onEnded = function () {
                _this6.changePlayState(false);
              };
              _this6.midiBuffer = midiBuffer;
              return midiBuffer;
            }).then(function () {
              // At this point, everything slow has happened. midiBuffer.start will return very quickly and will start playing very quickly without lag.
              midiBuffer.start();
              // console.log(midiBuffer.duration)
              // setTimeout(()=>{this.changePlayState(false)}, midiBuffer.duration * 1000)
              return Promise.resolve();
            }).catch(function (error) {
              if (error.status === "NotSupported") {
                console.warn("not supported!");
                // stopAudioButton.setAttribute("style", "display:none;");
                var audioError = this.ref.current.querySelector(".audio-error");
                audioError.setAttribute("style", "");
              } else console.warn("synth error", error);
            });
          } else {
            var audioError = this.ref.current.querySelector(".audio-error");
            audioError.setAttribute("style", "");
            console.warn("failed!");
          }
        }
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      // keybind for reading out screen reader summary
      if ((e.metaKey || e.altKey) && e.shiftKey && e.which === 49 && !this.props.hintMode) {
        (0, _util.srSpeak)(this.generateSummary(), "hotkey-announcer");
      }
    }
  }, {
    key: "generateSummary",
    value: function generateSummary() {
      var splitPrecursor = this.props.precursor.split(" ");
      var clef = splitPrecursor[splitPrecursor.length - 1].replace(/\n/g, '');
      var newSummary = this.props.generalAnnotationAltText ? "Annotation is " + this.props.generalAnnotationAltText : "" + clef.charAt(0).toUpperCase() + clef.slice(1) + " clef. ";
      var keySignature = this.props.precursor.substring(this.props.precursor.indexOf("K:"), this.props.precursor.length);
      newSummary += _MusicUtil.key_signature_alt_text[keySignature.substring(keySignature.indexOf("K:") + 2, keySignature.indexOf(" "))] + " ";
      var currentNotes = this.getCurrentNotes();
      var altTextPitchMode = this.props.altTextMode === "pitch" || this.props.altTextMode === undefined;
      var perNoteAnnotations = this.props.perNoteAnnotationAltText !== undefined ? this.props.perNoteAnnotationAltText.split(",") : undefined;
      if (this.props.chordMode) {
        currentNotes.sort(function (a, b) {
          return a.verticalPos > b.verticalPos ? 1 : -1;
        });
        if (currentNotes.length === 0 || currentNotes[0].pitch === undefined && currentNotes.length === 1) {
          newSummary += "Staff is blank. ";
        } else {
          var notesInEnglish = currentNotes.length === 1 ? "Chord has note " : "Chord has notes " + (altTextPitchMode ? "" : "on ");
          for (var i = 0; i < currentNotes.length; ++i) {
            var correctOrIncorrect = "";
            if (this.props.chordAnswerState && this.props.chordAnswerState.hasOwnProperty(currentNotes[i].verticalPos)) {
              correctOrIncorrect = this.props.chordAnswerState[currentNotes[i].verticalPos] ? " correct" : " incorrect";
            }
            if (altTextPitchMode) {
              notesInEnglish += (0, _MusicUtil.describePitch)(currentNotes[i]) + correctOrIncorrect + (i + 1 !== currentNotes.length ? ", " : ". ");
            } else {
              // lineSpace mode
              notesInEnglish += describeLineSpace(currentNotes[i]) + correctOrIncorrect + (i + 1 !== currentNotes.length ? ", " : ". ");
            }
          }
          var missingNotes = "";
          var missingNotesCount = 0;
          if (!this.props.hintMode) {
            var missingNoteIndexes = this.getMissingNoteIndexes(currentNotes);
            for (var _i5 = 0; _i5 < missingNoteIndexes.length; ++_i5) {
              if (altTextPitchMode) {
                missingNotes += (0, _MusicUtil.describePitch)(this.props.correctPitches[missingNoteIndexes[_i5]], true) + ", ";
              } else {
                // lineSpace mode
                missingNotes += describeLineSpace(this.props.correctPitches[missingNoteIndexes[_i5]], true) + ", ";
              }
            }
            if (missingNoteIndexes.length > 0) {
              var noteText = "note" + (missingNotesCount > 1 ? "s" : "");
              notesInEnglish += "Chord is missing " + noteText + " at " + missingNotes.substring(0, missingNotes.lastIndexOf(", ")) + ". "; // replace last comma with a period
            }
          }

          newSummary += notesInEnglish;
        }
      } else {
        // scalebuilder
        var _notesInEnglish = "Staff has ".concat(currentNotes.length, " notes:");
        for (var _i6 = 0; _i6 < currentNotes.length; ++_i6) {
          _notesInEnglish += " Beat ".concat(_i6 + 1, ",");
          var currentNoteAnnotation = perNoteAnnotations ? ", Annotation is " + perNoteAnnotations[_i6] : "";
          if (currentNotes[_i6] === "z") {
            _notesInEnglish += " missing note" + currentNoteAnnotation;
          } else {
            if (altTextPitchMode) {
              _notesInEnglish += " " + (0, _MusicUtil.describePitch)(currentNotes[_i6]) + currentNoteAnnotation;
            } else {
              // lineSpace mode
              _notesInEnglish += " " + describeLineSpace(currentNotes[_i6]) + currentNoteAnnotation;
            }
          }
          _notesInEnglish += ". ";
        }
        newSummary += _notesInEnglish;
      }
      return newSummary;
    }
  }, {
    key: "resetCursor",
    value: function resetCursor() {
      this.setState({
        cursorNote: 0,
        cursorPitch: this.clef === "treble" ? 0 : this.clef === "alto" ? 6 : 12
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      DEBUG && console.log("MusicEditor render");
      var renderTopBar = true;
      if (Object.keys(_MusicUtil.accidentals).map(function (a) {
        return _this7.props[_MusicUtil.accidentals_to_props[a]];
      }).filter(function (a) {
        return a;
      }).length === 0) {
        renderTopBar = false;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref
      }, !this.state.screenTooSmall && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !this.props.hintMode && renderTopBar && !this.props.completed && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          justifyContent: "center",
          display: "flex"
        }
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.AccidentalButtons, {
        accidental: this.state.accidental,
        accidentals: _MusicUtil.accidentals,
        accidentals_to_props: _MusicUtil.accidentals_to_props,
        musicButtonNote: this.props.musicButtonNote,
        setAccidental: this.setAccidental,
        activeButtons: this.props
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "music-editor" + (this.state.screenTooSmall ? " sr-only" : ""),
        ref: function ref(e) {
          _this7.container = e;
        },
        role: this.props.hintMode ? "img " : "application",
        "aria-describedby": 'summary' + (this.props.hintMode ? "-hint" : ""),
        "aria-hidden": this.state.screenTooSmall ? "true" : "false",
        "aria-live": "off" // prevent summary from being read on input
        ,
        onKeyDown: this.handleInput,
        onFocus: function onFocus() {
          _this7.setState({
            editorActive: true
          });
        },
        onBlur: function onBlur() {
          _this7.setState({
            editorActive: false
          });
        },
        onMouseLeave: function onMouseLeave() {
          _this7.setState({
            editorActive: false
          });
        },
        tabIndex: this.props.hintMode ? -1 : undefined
      }), !this.state.screenTooSmall && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: -1,
        id: "summary" + (this.props.hintMode ? "-hint" : ""),
        "aria-live": "off",
        className: "sr-only"
      }, " ", this.generateSummary()), !this.props.hintMode && /*#__PURE__*/_react.default.createElement("div", {
        id: "hotkey-announcer",
        className: "sr-only",
        tabIndex: -1,
        "aria-live": "polite"
      }), this.renderButtons()), this.state.screenTooSmall && !this.props.hintMode && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontSize: "x-large",
          display: "flex",
          justifyContent: "center",
          margin: "0px 40px"
        }
      }, /*#__PURE__*/_react.default.createElement("p", null, "The Music Editor does not support windows of this size.")));
    }
  }, {
    key: "setAccidental",
    value: function setAccidental(accidental) {
      this.setState({
        accidental: accidental
      });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this8 = this;
      var disabled;
      if (this.props.chordMode) {
        disabled = this.props.notation.trim() === "z";
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "left",
          float: "left",
          marginRight: "12px",
          width: "100%",
          marginTop: !this.props.chordMode && !this.props.hintMode ? "176px" : "0px"
        }
      }, this.props.musicButtonAudio && !this.props.hintMode && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        ref: function ref(e) {
          _this8.play = e;
        },
        "aria-label": "Play",
        disabled: disabled,
        onClick: this.playButton,
        className: disabled ? "music-function-button-disabled" : "music-function-button-enabled"
      }, this.state.playing ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        className: "play-pause-icon-image revert-dark-mode",
        src: _pause.default,
        alt: ""
      }), "Pause") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        className: "play-pause-icon-image revert-dark-mode",
        src: _play.default,
        alt: ""
      }), "Play"))), !this.props.completed && this.props.renderResetButton && this.props.renderResetButton(this.resetCursor), (!this.props.showAnswer && !this.props.hintMode || this.props.showAnswer && this.props.hintMode) && this.props.renderSubmitButton && this.props.renderSubmitButton(this.props.hintMode));
    }
  }]);
  return MusicEditor;
}(_react.default.Component);
exports.default = MusicEditor;
MusicEditor.contextType = _CompletedContext.CompletedContext;